export const blockIconsSocialScience = (
	<span className='material-symbols-outlined'>science</span>
);
